import { z } from "zod";
import { isoDateTime, nullableText, paginationQuerySchema, turnstileTokenSchema } from "./common";

export const bugReportInputSchema = z.object({
  gameSlug: z.string().min(1).max(120).optional(),
  name: z.string().trim().min(1).max(120),
  email: z.email().max(254),
  description: z.string().trim().min(10).max(2000),
  pageUrl: z.string().max(2000).optional(),
  turnstileToken: turnstileTokenSchema,
});
export type BugReportInput = z.infer<typeof bugReportInputSchema>;

export const contactInputSchema = z.object({
  name: z.string().trim().min(1).max(120),
  contact: z.string().trim().min(3).max(200),
  message: z.string().trim().min(5).max(4000),
  turnstileToken: turnstileTokenSchema,
});
export type ContactInput = z.infer<typeof contactInputSchema>;

export const bugReportStatusSchema = z.enum(["new", "triaged", "resolved", "dismissed"]);
export const contactStatusSchema = z.enum(["new", "in_progress", "closed", "spam"]);

export const adminBugReportSchema = z.object({
  id: z.number().int(),
  game: z.object({ id: z.number().int(), slug: z.string(), name: z.string() }).nullable(),
  name: z.string(),
  email: z.string(),
  description: z.string(),
  pageUrl: z.string().nullable(),
  userAgent: z.string().nullable(),
  country: z.string().nullable(),
  status: bugReportStatusSchema,
  adminNote: z.string().nullable(),
  handledAt: isoDateTime.nullable(),
  createdAt: isoDateTime,
});
export type AdminBugReport = z.infer<typeof adminBugReportSchema>;

export const adminContactSchema = z.object({
  id: z.number().int(),
  name: z.string(),
  contact: z.string(),
  message: z.string(),
  country: z.string().nullable(),
  status: contactStatusSchema,
  adminNote: z.string().nullable(),
  handledAt: isoDateTime.nullable(),
  createdAt: isoDateTime,
});
export type AdminContact = z.infer<typeof adminContactSchema>;

export const bugReportListQuerySchema = paginationQuerySchema.extend({
  q: z.string().trim().max(200).optional(),
  status: bugReportStatusSchema.optional(),
  gameId: z.coerce.number().int().positive().optional(),
});
export const contactListQuerySchema = paginationQuerySchema.extend({
  q: z.string().trim().max(200).optional(),
  status: contactStatusSchema.optional(),
});

export const bugReportUpdateSchema = z.object({
  status: bugReportStatusSchema,
  adminNote: nullableText(2000).optional(),
});
export const contactUpdateSchema = z.object({
  status: contactStatusSchema,
  adminNote: nullableText(2000).optional(),
});
